var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36538 8.21154L1.28845 4.17308L9.36538 1L17.1538 4.17308L9.36538 8.21154Z",
    fill: "#485F7D",
    stroke: "#485F7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36536 8.21156V16L17.4423 11.6731V4.1731",
    stroke: "#485F7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0769 8.21156V16L0.999982 11.6731V4.1731",
    stroke: "#485F7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51184 11.3749L1.75781 4.97968L8.58805 8.52129L8.83401 15.1622L1.51184 11.3749Z",
    fill: "#485F7D",
    stroke: "#485F7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.05159a8dd0ff425115ff81aca3844359.svg";
export { ForwardRef as ReactComponent };